/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_RecordsInputs */

const cs_integrations_records = /** @type {(inputs: Integrations_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořeno / aktualizováno / chyby`)
};

const en_integrations_records = /** @type {(inputs: Integrations_RecordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created / updated / failed`)
};

/**
* | output |
* | --- |
* | "Created / updated / failed" |
*
* @param {Integrations_RecordsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integrations_records = /** @type {((inputs?: Integrations_RecordsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_RecordsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integrations_records(inputs)
	return cs_integrations_records(inputs)
});